






import { teacherTypes } from '../../../shared/enums/teacherTypes';
import { ParticipantModel } from '../../../shared/models/participant.model';
import { lessonStatus } from '../../../shared/enums/lessonStatus';

interface Lesson {
  hasRelevantNote: boolean;
  lessonStatus: lessonStatus;
  participants: ParticipantModel[];
}

export default {
  props: {
    lesson: { type: Object as () => Lesson, required: true },
    invitedGroups: { type: Array, default: null },
    location: { type: String, default: null },
  },
  computed: {
    hasSubstituteStatus(): boolean {
      return this.lesson.lessonStatus == lessonStatus.SUBSTITUTE;
    },
    lessonExtendedInfo(): string {
      const groupInfo = this.getMainGroupInfo;
      const teacherInfo = this.getTeacherInfo;

      const infoParts = [];
      if (this.location) {
        infoParts.push(this.location);
      }
      if (groupInfo) {
        infoParts.push(groupInfo);
      }
      if (teacherInfo) {
        infoParts.push(teacherInfo);
      }
      return infoParts.join(', ');
    },
    getMainGroupInfo(): string {
      return this.invitedGroups?.map(group => group.name).join(', ') ?? '';
    },
    getTeacherInfo(): string {
      if (!this.lesson.participants || this.lesson.participants.length === 0) {
        return '';
      }

      const substituteTeachers = this.lesson.participants
        .filter(participant => participant.participantRole === teacherTypes.SUBSTITUTE)
        .map(participant => participant.teacherInitials);

      if (substituteTeachers.length > 0) {
        return substituteTeachers.join(', ');
      }

      const otherTeachers = this.lesson.participants
        .filter(
          participant =>
            participant.participantRole === teacherTypes.PRIMARY ||
            participant.participantRole === teacherTypes.HELP ||
            participant.participantRole === teacherTypes.PEDAGOGUE
        )
        .map(participant => participant.teacherInitials);

      return otherTeachers.join(', ');
    },
  },
};
